import React from "react";
import styled from "styled-components";
import { STYLES } from "../../constants";

function Button({ primary = STYLES.color.blue, ...rest }) {
  return <SButton primary={primary} {...rest} />;
}

const SButton = styled("div")`
  padding: 10px 28px;
  border-radius: 1px;
  background-color: ${({ primary }) => primary};
  font-size: 14px;
  border: none;
  color: #fff;
  font-weight: bold;
  text-decoration: none;
  outline: none;
  cursor: pointer;

  ${({ size }) =>
    size === "lg" &&
    `
    padding: 15px 30px;
    font-size: 18px;
  `}

  ${({ outline, primary }) =>
    outline &&
    `
    border: 1px solid ${primary};
    background: transparent;
    color: ${primary};
  `}
    
  &:hover,
  &:active,
  &:focus {
    color: #ffffff;
    text-decoration: none;
    ${({ outline, primary }) => outline && `color: ${primary};`}
  }
`;

export default Button;
